import { Link } from "react-router-dom";
import { BookOpen, Users, FileText, Building, Globe, Handshake, Eye, ArrowRight, Download, ExternalLink, Heart, TrendingUp, Shield, Landmark, Megaphone, HeartHandshake, GraduationCap } from "lucide-react";

const SERVIZI_RAPPRESENTANZA = [
  {
    icon: Megaphone,
    titolo: "Dialogo con le Istituzioni",
    desc: "Confcommercio Roma lavora incessantemente per creare un solido dialogo con le istituzioni locali, regionali e nazionali. Le decisioni politiche spesso non rispecchiano le esigenze quotidiane degli imprenditori, e il nostro ruolo è portare le loro necessità sui tavoli decisionali, promuovendo politiche che favoriscano la crescita e lo sviluppo delle attività commerciali, turistiche e professionali.",
  },
  {
    icon: Users,
    titolo: "Supporto e Consulenza per le Aziende",
    desc: "Rappresentare significa essere anche un punto di riferimento per il supporto pratico. Offriamo assistenza su problemi burocratici, consulenze fiscali e supporto per la gestione delle difficoltà quotidiane, aiutando gli imprenditori a concentrarsi su ciò che sanno fare meglio: far crescere le loro attività.",
  },
  {
    icon: HeartHandshake,
    titolo: "Lavoro e Welfare Aziendale",
    desc: "Il lavoro e il welfare sono al centro della nostra azione di rappresentanza. Affianchiamo le imprese nella contrattazione dei CCNL di categoria e nei rapporti con le organizzazioni sindacali, offrendo consulenza su gestione del personale, relazioni industriali e welfare aziendale. Un piano di welfare efficace non è un costo, ma un investimento nel benessere dei collaboratori e nella competitività dell'impresa.",
  },
  {
    icon: GraduationCap,
    titolo: "Formazione e Aggiornamento per le Imprese",
    desc: "La rappresentanza per noi significa anche evoluzione. Offriamo ai nostri associati opportunità di formazione continua, essenziale per affrontare le sfide di un mercato in continua evoluzione. Restare aggiornati su normative, tecnologie e tendenze è fondamentale per ogni impresa che vuole competere con successo a livello locale e globale.",
  },
];

const SECTIONS = [
  { path: "/chi-siamo/organismi", icon: Users, titolo: "Organismi", desc: "Presidente, Direttore, Giunta e Consiglio Direttivo." },
  { path: "/chi-siamo/statuto-e-regolamenti", icon: FileText, titolo: "Statuto e Regolamenti", desc: "Documenti istituzionali, codice etico, certificazioni." },
  { path: "/associazioni", icon: Building, titolo: "Associazioni", desc: "15 Federazioni e Associazioni di categoria del territorio." },
  { path: "/chi-siamo/enti-collegati/promo-ter", icon: Globe, titolo: "Promo.Ter", desc: "Società di servizi per formazione professionale, consulenza e assistenza alle imprese." },
  { path: "/chi-siamo/cat", icon: Globe, titolo: "C.A.T. Confcommercio Roma", desc: "Centro di Assistenza Tecnica per le imprese del commercio, turismo e servizi di Roma." },
  { path: "/chi-siamo/partner", icon: Handshake, titolo: "Partner", desc: "50&Piu Enasco, CIOL, EBIT, Finpromoter, Fon.Te., For.Te., Sanimpresa." },
  { path: "/chi-siamo/trasparenza", icon: Eye, titolo: "Trasparenza", desc: "Archivio contributi pubblici e pubblicazioni." },
];

const SECTION_IMAGES = {
  "Organismi": "/local-assets/chisiamo-organismi-section.webp",
  "Statuto e Regolamenti": "/local-assets/chisiamo-statuto-section.webp",
  "Associazioni": "https://images.unsplash.com/photo-1651372381086-9861c9c81db5?w=600&q=80&auto=format",
  "Promo.Ter": "/local-assets/chisiamo-promoter-section.webp",
  "C.A.T. Confcommercio Roma": "/local-assets/chisiamo-cat-section.webp",
  "Partner": "/local-assets/chisiamo-partner-section.webp",
  "Trasparenza": "/local-assets/chisiamo-trasparenza-section.webp",
};

const TIMELINE = [
  { anno: "1944", titolo: "La fondazione", desc: "19 associazioni e sindacati di categoria danno vita al primo nucleo di Confcommercio Roma." },
  { anno: "1971", titolo: "La crescita", desc: "La Confederazione diventa la voce del commercio, del turismo e dei servizi nella Capitale." },
  { anno: "2006", titolo: "Modernizzazione", desc: "Trasparenza, riforma statutaria e digitalizzazione sotto la presidenza Sangalli." },
  { anno: "2024", titolo: "80 anni", desc: "Celebrazione con il Tour Roadshow itinerante su tutto il territorio romano." },
  { anno: "2025", titolo: "Nuovo logo", desc: "Identita visiva rinnovata: lineare, essenziale, moderna. Lo sguardo al futuro." },
  { anno: "2026", titolo: "La storia continua", desc: "Nuove sfide, nuove opportunità: Confcommercio Roma guarda avanti, sempre al fianco delle imprese." },
];

export default function ChiSiamoPage() {
  return (
    <main id="main-content" data-testid="chi-siamo-page">
      {/* Hero */}
      <section className="relative h-[320px] md:h-[380px] overflow-hidden" aria-labelledby="chisiamo-title">
        <img src="/local-assets/chisiamo-hero-pantheon.webp" alt="Roma" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(4, 30, 66, 0.82)" }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative h-full flex flex-col justify-end pb-12">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">L'Associazione</span>
          <h1 id="chisiamo-title" className="text-4xl md:text-5xl font-bold text-white mt-3 font-['Encode_Sans_Semi_Condensed'] tracking-tight">Chi Siamo</h1>
          <p className="text-lg text-white/80 mt-4 max-w-3xl">
            Confederazione Generale Italiana delle Imprese, delle Attività Professionali e del Lavoro Autonomo
          </p>
        </div>
      </section>

      {/* Timeline orizzontale */}
      <section className="py-16 bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">La nostra storia</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[var(--confcom-text-primary)] mt-3 font-['Encode_Sans_Semi_Condensed'] tracking-tight">Dal 1944 al fianco delle imprese</h2>
          </div>
          {/* Timeline */}
          <div className="relative">
            <div className="hidden md:block absolute top-[40px] left-0 right-0 h-[2px] bg-gradient-to-r from-[var(--confcom-blue)] via-[#56B7E6] to-[var(--confcom-blue)]" />
            <div className="grid grid-cols-2 md:grid-cols-6 gap-6">
              {TIMELINE.map((t, i) => (
                <div key={t.anno} className="relative text-center">
                  <div className="relative z-10 w-20 h-20 bg-[var(--confcom-blue)] rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                    <span className="text-xl font-bold text-white font-['Encode_Sans_Semi_Condensed']">{t.anno}</span>
                  </div>
                  <h3 className="text-base font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-1">{t.titolo}</h3>
                  <p className="text-xs text-[var(--confcom-text-secondary)] leading-relaxed">{t.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Zig-zag storytelling */}
      <section className="py-16 bg-[#EBF5FF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
          {/* Blocco 1: testo sx, foto dx */}
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-lg text-[var(--confcom-text-secondary)] leading-relaxed mb-4">La nostra storia è iniziata l'<strong className="text-[var(--confcom-text-primary)]">11 ottobre del 1944</strong> quando un piccolo gruppo di imprenditori, con spirito di libertà e voglia di ricostruire, diede vita a 19 associazioni che costituirono il primo nucleo di Confcommercio Roma.</p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">Da allora siamo cresciuti lavorando al fianco delle imprese, ascoltando le loro esigenze e costruendo insieme soluzioni efficaci per stare al passo con i tempi.</p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed">L'esperienza maturata ha permesso all'associazione di diventare l'<strong className="text-[var(--confcom-text-primary)]">interlocutore privilegiato</strong> di Enti e Amministrazioni locali.</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img src="/local-assets/chisiamo-storia-colosseo.webp" alt="Colosseo, Roma" className="w-full h-[300px] object-cover" />
            </div>
          </div>
          {/* Blocco 2: foto sx, testo dx */}
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="rounded-2xl overflow-hidden shadow-lg order-2 lg:order-1">
              <img src="/local-assets/chisiamo-impresa-office.webp" alt="Imprese associate" className="w-full h-[300px] object-cover" />
            </div>
            <div className="order-1 lg:order-2">
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">Oggi le imprese associate provengono dai più svariati settori: dall'accoglienza alla ristorazione, dalla consulenza alla sicurezza, dal commercio alla distribuzione.</p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-6">Scelgono di far parte del nostro sistema perché sanno di poter contare sui consigli e l'assistenza dei nostri esperti fin dai primissimi momenti d'attività.</p>
              <a href="https://www.confcommercioroma.it/wp-content/uploads/2024/05/COMPANY-PROFILE-CONFCOMMERCIO-ROMA.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[var(--confcom-blue)] text-white px-7 py-3 rounded-md font-medium hover:opacity-90 transition-opacity text-sm">
                <Download size={16} aria-hidden="true" /> Brochure Istituzionale (PDF)
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Numeri d'impatto */}
      <section className="py-16 relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=1920&q=60&auto=format" alt="" className="w-full h-full object-cover" aria-hidden="true" />
          <div className="absolute inset-0" style={{ backgroundColor: "rgba(4, 30, 66, 0.92)" }} />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8 text-center">
            {[
              { value: "80", suffix: "", label: "Anni di storia" },
              { value: "26", suffix: "", label: "Associazioni rappresentate" },
              { value: "40.000", suffix: "+", label: "Lavoratori rappresentati" },
            ].map((stat) => (
              <div key={stat.label} className="bg-white/[0.08] backdrop-blur-sm border border-white/10 rounded-2xl p-8">
                <div className="text-4xl md:text-5xl font-bold text-white font-['Encode_Sans_Semi_Condensed']">{stat.value}<span className="text-[#56B7E6]">{stat.suffix}</span></div>
                <div className="text-sm text-white/60 mt-2">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission e Vision — blocco immersivo */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-0">
            {/* Vision */}
            <div className="p-10 md:p-14 bg-[#041E42] rounded-t-2xl md:rounded-l-2xl md:rounded-tr-none">
              <div className="w-14 h-14 bg-white/10 rounded-2xl flex items-center justify-center mb-6">
                <Landmark size={28} className="text-[#56B7E6]" aria-hidden="true" />
              </div>
              <h2 className="text-2xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] mb-6">Vision</h2>
              <div className="text-white/70 leading-relaxed space-y-4">
                <p>Immaginiamo una Roma capace di crescere facendo leva sulla forza delle sue imprese, del commercio, dei servizi e delle professioni. Una città più accessibile, sostenibile ed efficiente, nella quale sviluppo economico e qualità della vita procedano insieme.</p>
                <p>Vogliamo quartieri vivi, sicuri e curati, nei quali le attività economiche contribuiscano ogni giorno alla qualità dei luoghi e delle relazioni. Una Roma in cui imprese e professionisti siano parte di una rete connessa, capace di collaborare, innovare e generare nuove opportunità.</p>
                <p>La nostra visione è quella di un <strong className="text-white">sistema economico romano forte e riconoscibile</strong>, che sappia valorizzare l'identità della città e, allo stesso tempo, affrontarne i cambiamenti e le nuove sfide.</p>
              </div>
            </div>
            {/* Mission */}
            <div className="p-10 md:p-14 bg-[var(--confcom-blue)] rounded-b-2xl md:rounded-r-2xl md:rounded-bl-none">
              <div className="w-14 h-14 bg-white/15 rounded-2xl flex items-center justify-center mb-6">
                <TrendingUp size={28} className="text-white" aria-hidden="true" />
              </div>
              <h2 className="text-2xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] mb-6">Mission</h2>
              <div className="text-white/80 leading-relaxed space-y-4">
                <p>Confcommercio Roma rappresenta le imprese, le associazioni e i professionisti del territorio, ne raccoglie le esigenze e le porta nel confronto con le istituzioni, contribuendo alle decisioni che incidono sul loro lavoro e sullo sviluppo della città.</p>
                <p>Trasformiamo questa capacità di ascolto e rappresentanza in <strong className="text-white">risposte concrete</strong>: servizi, formazione, relazioni, partnership e progetti che aiutano imprese e professionisti ad affrontare i cambiamenti, cogliere nuove opportunità e crescere.</p>
                <p>Mettiamo in connessione competenze, imprese e opportunità, favorendo la collaborazione all'interno del sistema Confcommercio e sul territorio. Il nostro obiettivo è rendere più semplice <strong className="text-white">fare impresa a Roma</strong> e contribuire a un tessuto economico più solido, competitivo e capace di evolvere.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Enti Collegati */}
      {/* I nostri servizi di rappresentanza per le aziende — trasportata da /chi-siamo/rappresentanza (#0089) */}
      <section id="servizi-rappresentanza" className="py-16 bg-white" data-testid="servizi-rappresentanza">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Al fianco delle imprese</span>
            <h2 className="text-2xl md:text-3xl font-bold text-[var(--confcom-text-primary)] mt-3 font-['Encode_Sans_Semi_Condensed'] tracking-tight">
              Rappresentanza e servizi per le aziende
            </h2>
          </div>
          <div className="grid sm:grid-cols-2 gap-6">
            {SERVIZI_RAPPRESENTANZA.map((item) => {
              const Icon = item.icon;
              return (
                <div key={item.titolo} className="flex gap-5 p-6 rounded-xl border border-[var(--confcom-border)] hover:shadow-md hover:border-[var(--confcom-blue)]/30 transition-all">
                  <div className="w-11 h-11 bg-[var(--confcom-bg-blue-light)] rounded-xl flex items-center justify-center shrink-0">
                    <Icon size={22} className="text-[var(--confcom-blue)]" aria-hidden="true" />
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-2">{item.titolo}</h3>
                    <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="pb-16 bg-white border-t border-[var(--confcom-border)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">La nostra rete</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[var(--confcom-text-primary)] mt-3 font-['Encode_Sans_Semi_Condensed'] tracking-tight">Società di Servizi</h2>
            <p className="text-[var(--confcom-text-secondary)] leading-relaxed mt-4">
              Confcommercio Roma risponde alle esigenze delle imprese attraverso le proprie società di servizi.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <Link to="/chi-siamo/enti-collegati/promo-ter" className="rounded-2xl border border-[var(--confcom-border)] bg-[#EBF5FF] hover:shadow-md hover:border-[var(--confcom-blue)]/40 transition-all overflow-hidden group" data-testid="ente-promoter">
              <div className="bg-white flex items-center justify-center p-8 h-52">
                <img src="/logo-promoter.webp" alt="Promo.Ter - Formazione e servizi per il terziario" className="h-36 object-contain group-hover:scale-105 transition-transform duration-300" />
              </div>
              <div className="p-8">
                <h3 className="text-xl font-bold text-[var(--confcom-blue)] font-['Encode_Sans_Semi_Condensed'] mb-4 group-hover:underline">Promo.Ter</h3>
                <p className="text-[var(--confcom-text-secondary)] leading-relaxed">
                  Società di servizi di Confcommercio Roma per formazione professionale, consulenza e assistenza alle imprese associate. Eroga corsi obbligatori (sicurezza, HACCP, privacy), abilitanti (PIA ex-REC, agenti immobiliari) e supporta le aziende nell'accesso a formazione finanziata e credito d'imposta 4.0.
                </p>
                <span className="inline-flex items-center gap-1 mt-4 text-sm font-medium text-[var(--confcom-blue)]">
                  Scopri Promo.Ter <ArrowRight size={14} aria-hidden="true" />
                </span>
              </div>
            </Link>
            <Link to="/chi-siamo/cat" className="rounded-2xl border border-[var(--confcom-border)] bg-[#EBF5FF] hover:shadow-md hover:border-[var(--confcom-blue)]/40 transition-all overflow-hidden group" data-testid="ente-cat">
              <div className="bg-white flex items-center justify-center p-8 h-52">
                <img src="/logo-cat.webp" alt="C.A.T. - Centro di Assistenza Tecnica Confcommercio Roma" className="h-36 object-contain group-hover:scale-105 transition-transform duration-300" />
              </div>
              <div className="p-8">
                <h3 className="text-xl font-bold text-[var(--confcom-blue)] font-['Encode_Sans_Semi_Condensed'] mb-4 group-hover:underline">C.A.T. Confcommercio Roma</h3>
                <p className="text-[var(--confcom-text-secondary)] leading-relaxed">
                  Centro di Assistenza Tecnica per le imprese del commercio, turismo e servizi nel Lazio. Offre supporto tecnico, consulenza specializzata e servizi di accompagnamento per lo sviluppo e la crescita delle imprese del terziario nel territorio regionale.
                </p>
                <span className="inline-flex items-center gap-1 mt-4 text-sm font-medium text-[var(--confcom-blue)]">
                  Scopri C.A.T. <ArrowRight size={14} aria-hidden="true" />
                </span>
              </div>
            </Link>
          </div>
          <div className="text-center mt-8">
            <Link to="/chi-siamo/cat" className="inline-flex items-center gap-2 bg-[var(--confcom-blue)] text-white px-7 py-3 rounded-md font-medium hover:opacity-90 transition-opacity text-sm" data-testid="cta-enti-collegati">
              Scopri i nostri servizi <ArrowRight size={16} aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>

      {/* 80 anni + Video */}
      <section className="py-16 bg-[#EBF5FF]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed']">Gli 80 anni di Confcommercio Roma</h2>
            <p className="text-[var(--confcom-text-secondary)] mt-3">Istituzioni, imprenditori e cittàdini insieme per il futuro del commercio nella Capitale.</p>
          </div>
          <div className="rounded-xl overflow-hidden border border-[var(--confcom-border)] shadow-lg" data-testid="video-80-anni">
            <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
              <iframe
                className="absolute inset-0 w-full h-full"
                src="https://www.youtube.com/embed/OJIZwAiWWj8"
                title="Gli 80 anni di Confcommercio Roma"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              />
            </div>
          </div>
          <div className="mt-6 text-center">
            <a href="https://www.confcommercioroma.it/progetti/80-anni-tour-roadshow/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[var(--confcom-blue)] text-white px-7 py-3 rounded-md font-medium hover:opacity-90 transition-opacity text-sm" data-testid="cta-roadshow">
              <ExternalLink size={16} aria-hidden="true" /> Scopri il progetto 80 Anni Tour Roadshow
            </a>
          </div>
        </div>
      </section>

      {/* Sezioni di navigazione */}
      <section className="py-16 bg-[var(--confcom-bg-subtle)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-10 text-center">Scopri di piu</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SECTIONS.map((s) => (
              <Link key={s.path} to={s.path} className="group bg-white rounded-xl overflow-hidden border border-[var(--confcom-border)] hover:border-[var(--confcom-blue)]/30 hover:shadow-lg transition-all" data-testid={`chisiamo-link-${s.titolo.toLowerCase().replace(/\s/g, "-")}`}>
                <div className="h-40 overflow-hidden">
                  <img src={SECTION_IMAGES[s.titolo]} alt={s.titolo} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                </div>
                <div className="p-6">
                  <s.icon size={24} className="text-[var(--confcom-blue)] mb-3 group-hover:scale-110 transition-transform" aria-hidden="true" />
                  <h3 className="text-lg font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-2 group-hover:text-[var(--confcom-blue)] transition-colors">{s.titolo}</h3>
                  <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed mb-4">{s.desc}</p>
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-[var(--confcom-blue)] group-hover:gap-2 transition-all">
                    Scopri <ArrowRight size={14} aria-hidden="true" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
